import {Box, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {RunnerQuestionProps} from "./runnerQuestion.types";
import {surveyMarkdownToPlainText} from "../../shared/surveyMarkdownText.util";

const FIELD_MAX_WIDTH = 320;

const formatDate = (isoDate: string | undefined, language: string): string => {
    if (!isoDate) return '';

    const parsed = new Date(`${isoDate}T12:00:00`);
    if (Number.isNaN(parsed.getTime())) return isoDate;

    try {
        return new Intl.DateTimeFormat(language, {dateStyle: 'long'}).format(parsed);
    } catch {
        return isoDate;
    }
};

function DateQuestion({question, localize, language, value, onAnswerChange}: RunnerQuestionProps) {
    const {t} = useTranslation(undefined, {lng: language});

    const [localDate, setLocalDate] = useState('');

    const date = value?.dateValue ?? localDate;

    const pick = (next: string) => {
        setLocalDate(next);
        onAnswerChange?.({...value, dateValue: next});
    };

    const from = formatDate(question.minDate, language);
    const to = formatDate(question.maxDate, language);

    const rangeCaption = from && to
        ? t('Between {{from}} and {{to}}', {from, to})
        : from
            ? t('From {{from}}', {from})
            : to
                ? t('Until {{to}}', {to})
                : undefined;

    return (
        <Box sx={{width: '100%'}}>
            <TextField
                fullWidth
                required={!!question.isRequired}
                type={'date'}
                value={date}
                onChange={(event) => pick(event.target.value)}
                inputProps={{min: question.minDate, max: question.maxDate, 'aria-label': surveyMarkdownToPlainText(localize(question.title))}}
                sx={{maxWidth: FIELD_MAX_WIDTH}}
            />

            {!!rangeCaption && (
                <Typography variant={'body2'} color={'text.secondary'} sx={{mt: 0.5}}>
                    {rangeCaption}
                </Typography>
            )}
        </Box>
    );
}

export default DateQuestion;
